export default {"src":"/_next/static/media/hyperlink_icon.67ea7929.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};